import * as React from 'react'

export interface IRecordRefTagProps {
  refTag?: string
  children?: JSX.Element
  className?: string
}

// Temporary workaround for reftag reporting until client side React
// piggibacking on the AmazonVideoUICompatibilityJS asset
export const RecordRefTag = ({
  refTag,
  children,
  className = ''
}: IRecordRefTagProps) =>
  !refTag ? (
    <>children</>
  ) : (
    <span
      className={`a-declarative ${className}`}
      data-action='dv-record-reftag'
      data-dv-record-reftag={`{"reftag":"${refTag}"}`}>
      {children}
    </span>
  )
